<template>
  <BannerMtLink
    :text="bannerText"
    data-qa="lpu_doctors_list_mt_banner"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import BannerMtLink from 'src/components/common/BannerMtLink/BannerMtLink.vue'

const bannerText = computed(() => (
  tStatic('К этим врачам можно приходить с электронной медкартой')
))
</script>
